import { deburr } from 'lodash';

export const isMatchingTitle = (title: string, searchString: string) => {
  const sanitizedTitle = deburr(title.toLowerCase());
  const sanitizedSearchString = deburr(searchString.toLowerCase().trim());

  return sanitizedTitle.includes(sanitizedSearchString);
};
